<script setup>

import {computed, inject, ref} from "vue";
import {useI18n} from "vue-i18n";

const localeToUse = ref("de-AT")

import {useFrontEndStore} from "@/stores/frontEndStore";
import { useCommunitiesStore } from "@/stores/communitiesStore";
import { useMeteringPointMembershipsStore } from "@/stores/meteringPointMembershipsStore";

const billingPeriodDateStart2023 = ref(new Date(2023,1-1,1));
const billingPeriodDateEnd2023   = ref(new Date(2023,12-1,31));

const billingPeriodDateStart2024 = ref(new Date(2024,1-1,1));
const billingPeriodDateEnd2024   = ref(new Date(2024,12-1,31));

const billingPeriodDateStart2025 = ref(new Date(2025,1-1,1));
const billingPeriodDateEnd2025   = ref(new Date(2025,12-1,31));

const billingPeriodDateEndNewModel   = ref(new Date(2026,12-1,31));

const { t } = useI18n();
const $log = inject('log');

const frontEndStore = useFrontEndStore();
const communitiesStore = useCommunitiesStore();
const mpmStore = useMeteringPointMembershipsStore();

const communitiesReport = computed(() => {
  let cr = [];

  for(const c of  communitiesStore.allCommunities) {
    // $log.warn(c);

    const mpms = mpmStore.allMeteringPointMemberships.filter(mpm => mpm.ecid === c.ecid);
    let mpmsCalced2023 = [];
    let mpmsCalced2024 = [];
    let mpmsCalced2025 = [];
    let mpmMonth2023 = 0;
    let mpmMonth2024 = 0;
    let mpmMonth2025 = 0;

    /// memberships 2023 post calc (Energieabhängiges Modell)
    for(const mpm of mpms) {

      // never reached active state
      if(mpm.membershipStatus === "CREATED")
        continue;
      if(mpm.membershipStatus === "STARTED")
        continue;
      if(mpm.membershipStatus === "DECLINED")
        continue;
      if(mpm.membershipStatus === "WAITING_FOR_USER")
        continue;
      if(mpm.membershipStatus === "ACCEPTED")
        continue;
      if(mpm.membershipStatus === "ABORTED")
        continue;

      // ended before our time period
      if(mpm.dateEnd && mpm.dateEnd < billingPeriodDateStart2023.value)
        continue;
      if(mpm.dateStart > billingPeriodDateEnd2023.value)
        continue;

      let monthStart = 1;
      let monthEnd   = 12;
      if(mpm.dateStart > billingPeriodDateStart2023.value)
        monthStart = mpm.dateStart.getMonth() + 1;
      if(mpm.dateEnd && mpm.dateEnd < billingPeriodDateEnd2023.value)
        monthEnd = mpm.dateEnd.getMonth() + 1;

      const countMonth = monthEnd-monthStart + 1;
      mpmMonth2023+=countMonth;

      mpmsCalced2023.push({
        ...mpm,
        countMonth,
      })
    }

    /// memberships 2024 post calc (Energieabhängiges Modell)
    for(const mpm of mpms) {

      // never reached active state
      if(mpm.membershipStatus === "CREATED")
        continue;
      if(mpm.membershipStatus === "STARTED")
        continue;
      if(mpm.membershipStatus === "DECLINED")
        continue;
      if(mpm.membershipStatus === "WAITING_FOR_USER")
        continue;
      if(mpm.membershipStatus === "ACCEPTED")
        continue;
      if(mpm.membershipStatus === "ABORTED")
        continue;

      // ended before our time period
      if(mpm.dateEnd && mpm.dateEnd < billingPeriodDateStart2024.value)
        continue;
      if(mpm.dateStart > billingPeriodDateEnd2024.value)
        continue;

      let monthStart = 1;
      let monthEnd   = 12;
      if(mpm.dateStart > billingPeriodDateStart2024.value)
        monthStart = mpm.dateStart.getMonth() + 1;
      if(mpm.dateEnd && mpm.dateEnd < billingPeriodDateEnd2024.value)
        monthEnd = mpm.dateEnd.getMonth() + 1;

      const countMonth = monthEnd-monthStart + 1;
      mpmMonth2024+=countMonth;

      mpmsCalced2024.push({
        ...mpm,
        countMonth,
      })
    }

    /// memberships 2025 post calc (Energieabhängiges Modell)
    for(const mpm of mpms) {

      // never reached active state
      if(mpm.membershipStatus === "CREATED")
        continue;
      if(mpm.membershipStatus === "STARTED")
        continue;
      if(mpm.membershipStatus === "DECLINED")
        continue;
      if(mpm.membershipStatus === "WAITING_FOR_USER")
        continue;
      if(mpm.membershipStatus === "ACCEPTED")
        continue;
      if(mpm.membershipStatus === "ABORTED")
        continue;

      // ended before our time period
      if(mpm.dateEnd && mpm.dateEnd < billingPeriodDateStart2025.value)
        continue;
      if(mpm.dateStart > billingPeriodDateEnd2025.value)
        continue;

      let monthStart = 1;
      let monthEnd   = 12;
      if(mpm.dateStart > billingPeriodDateStart2025.value)
        monthStart = mpm.dateStart.getMonth() + 1;
      if(mpm.dateEnd && mpm.dateEnd < billingPeriodDateEnd2025.value)
        monthEnd = mpm.dateEnd.getMonth() + 1;

      const countMonth = monthEnd-monthStart + 1;
      mpmMonth2025+=countMonth;

      mpmsCalced2025.push({
        ...mpm,
        countMonth,
      })
    }


    /// membership calc 2024 (Pauschalmodell)
    let md = [];
    let dateCurrent = new Date(billingPeriodDateStart2024.value);

    while(dateCurrent <= billingPeriodDateEndNewModel.value) {
      const dateStart = dateCurrent;
      let dateEnd = new Date(dateStart);
      dateEnd.setMonth(dateEnd.getMonth()+1)
      dateEnd.setDate(0);

      let mpsAccountedFor = [];
      let mpsMultiple = [];

      let countMpmActive = 0;
      let countMpmActivated = 0;
      let countMpmDeactivated = 0;
      let countMpmActiveDouble = 0;

      for(const mpm of mpms) {

        // never reached active state
        if (mpm.membershipStatus === "CREATED")
          continue;
        if (mpm.membershipStatus === "STARTED")
          continue;
        if (mpm.membershipStatus === "DECLINED")
          continue;
        if (mpm.membershipStatus === "WAITING_FOR_USER")
          continue;
        if (mpm.membershipStatus === "ACCEPTED")
          continue;
        if(mpm.membershipStatus === "ABORTED")
          continue;

        // ended before our time period
        if (mpm.dateEnd && mpm.dateEnd < dateStart)
          continue;
        // started after
        if (mpm.dateStart > dateEnd)
          continue;

        // was active during month
        if(!mpsAccountedFor.includes(mpm.meteringPoint)) {
          countMpmActive++;

          mpsAccountedFor.push(mpm.meteringPoint)
        }
        else {
          $log.warn("MP was active more than once",dateStart.toLocaleDateString(localeToUse.value),mpm.meteringPoint,mpm.ecn);
          countMpmActiveDouble++;
          mpsMultiple.push(mpm.meteringPoint)
        }

        if (mpm.dateStart >= dateStart)
          countMpmActivated++;  // entry this month
        if (mpm.dateEnd &&  mpm.dateEnd <= dateEnd)
          countMpmDeactivated++; // exit this month
      }

      md.push({
        timespan: dateStart.toLocaleDateString(localeToUse.value)+" > "+dateEnd.toLocaleDateString(localeToUse.value),
        countMpmActive: countMpmActive,
        countMpmActivated: countMpmActivated,
        countMpmDeactivated: countMpmDeactivated,
        countMpmActiveDouble: countMpmActiveDouble,
        mpsMultiple: mpsMultiple,
      })
      dateCurrent.setMonth(dateCurrent.getMonth() + 1);
    }

    cr.push({
      ...c,
      mpmsAll: mpms,

      // for 2023 calc (Energieabhängiges Modell)
      mpms2023: mpmsCalced2023,
      mpms2024: mpmsCalced2024,
      mpms2025: mpmsCalced2025,
      mpmMonth2023,
      mpmMonth2024,
      mpmMonth2025,

      // for 2024 calc (Pauschalmodell)
      monthData: md,
    });
  }


  return cr;
});


</script>


<script>
export default {
  name: 'meteringPointsAnalysis',
}
</script>


<template>
  <v-container class="containerBase pa-0">

    <v-container class="containerStandard">

      <p class="textHeadline">{{ $t('meteringPoint') + " " + $t('analysis') }}</p>
      Analyse der Zählpunkte der Gemeinschaften über Zeit (für Abrechnung So-Strom/KundInnen).<br><br>
      <p>
        <u>Regeln:</u> Ein Monat für einen Zählpunkt wird verechnet, wenn dieser zumindest einen Tag lange aktiv war.
        EnergieUNabhängig: Pro Monat die aktiven und aktivierten Mitgliedschaften heranziehen + Basispauschale.<br>
        EnergieABhändig: Nachverrechnung Zählpunktmonate/-Jahre für 2023 (Differenz zur Rechnungslegung letztes Jahr)<br>
        sowie aktuell aktive Zählpunkte/Mitgliedschaften (Count MPMs ACTIVE) oder Eintrag vom Jänner (aktiv) - Mindestanzahl!
        Zusätzlich die Anmeldungen berücksichtigen.
      </p>

      <br>
      Start-Datum: {{ billingPeriodDateStart2023.toLocaleDateString(localeToUse) }}<br>
      End-Datum: {{ billingPeriodDateEnd2023.toLocaleDateString(localeToUse) }}<br>
      <br>

      <div v-for="community of communitiesReport" :key="community.ecn">
        <b>Name: {{community.name}} <br></b>
        ECN: {{community.ecn}} <br>
        ECID: {{community.ecid}} <br>
        <br>
        <u>Aktuelle Mitgliedschaften</u>:<br>
        Count MPMs all: {{ community.mpmsAll.length }}<br>
        Count MPMs CREATED: {{ community.mpmsAll.filter(mpm => mpm.membershipStatus === "CREATED").length }}<br>
        Count MPMs STARTED: {{ community.mpmsAll.filter(mpm => mpm.membershipStatus === "STARTED").length }}<br>
        Count MPMs DECLINED: {{ community.mpmsAll.filter(mpm => mpm.membershipStatus === "DECLINED").length }}<br>
        Count MPMs WAITING_FOR_USER: {{ community.mpmsAll.filter(mpm => mpm.membershipStatus === "WAITING_FOR_USER").length }}<br>
        Count MPMs ACCEPTED: {{ community.mpmsAll.filter(mpm => mpm.membershipStatus === "ACCEPTED").length }}<br>
        <u>Count MPMs ACTIVE: {{ community.mpmsAll.filter(mpm => mpm.membershipStatus === "ACTIVE" || mpm.membershipStatus === "ENDING").length }}</u><br>
        Count MPMs ENDED: {{ community.mpmsAll.filter(mpm => mpm.membershipStatus === "ENDED").length }}<br>
        Count MPMs ABORTED: {{ community.mpmsAll.filter(mpm => mpm.membershipStatus === "ABORTED").length }}<br>
        <br>

        <u>EnergieABhängiges Modell 2023:</u><br>
        Zählpunktmonate: {{community.mpmMonth2023}} <br>
        Zählpunktjahre: {{community.mpmMonth2023/12}} <br>
        <br>

        <u>EnergieABhängiges Modell 2024:</u><br>
        Zählpunktmonate: {{community.mpmMonth2024}} <br>
        Zählpunktjahre: {{community.mpmMonth2024/12}} <br>
        <br>

        <u>EnergieABhängiges Modell 2025:</u><br>
        Zählpunktmonate: {{community.mpmMonth2025}} <br>
        Zählpunktjahre: {{community.mpmMonth2025/12}} <br>
        <br>

        <u>EnergieUNabhängiges Modell: Mitgliedschaften aktiv zwischen {{ billingPeriodDateStart2024.toLocaleDateString(localeToUse) }} und {{ billingPeriodDateEnd2025.toLocaleDateString(localeToUse) }}:</u>
        <div v-for="(md, index) of community.monthData" :key="index">
          {{index+1}}: {{md.timespan}} <u>{{md.countMpmActive}}</u>/{{md.countMpmActivated}}/{{md.countMpmDeactivated}}/{{md.countMpmActiveDouble}} (<u>aktiv</u>/aktiviert/deaktiviert/nicht-als-aktiv-weil-Überlappung)<br>

          <div v-if="md.mpsMultiple.length > 0">
            Zählpunkte mehrfach aktiv:<br>
            <div v-for="(mp, index) of md.mpsMultiple" :key="index">
              {{mp}}<br>
            </div>
          </div>

          <div v-if="index%12 === 11"><br></div>
        </div>
        <br>

<!--        <u>EnergieABhängiges Modell: Mitgliedschaften aktiv zwischen {{ billingPeriodDateStart2023.toLocaleDateString(localeToUse) }} und {{ billingPeriodDateEnd2023.toLocaleDateString(localeToUse) }}:</u>-->
<!--        <div v-for="(mpm, index) of community.mpms2023">-->
<!--          {{index+1}}: {{mpm.meteringPoint}} {{mpm.meteringPointDirection}} ({{mpm.nameFriendly}})<br>-->
<!--          &nbsp;&nbsp; {{mpm.dateStart.toLocaleDateString(localeToUse) }} >> {{mpm.dateEnd?.toLocaleDateString(localeToUse)}} <br>-->
<!--          &nbsp;&nbsp; {{mpm.countMonth}} Zählpunktmonate <br>-->
<!--        </div>-->

<!--        <u>EnergieABhängiges Modell: Mitgliedschaften aktiv zwischen {{ billingPeriodDateStart2024.toLocaleDateString(localeToUse) }} und {{ billingPeriodDateEnd2024.toLocaleDateString(localeToUse) }}:</u>-->
<!--        <div v-for="(mpm, index) of community.mpms2024" :key="index">-->
<!--          {{index+1}}: {{mpm.meteringPoint}} {{mpm.meteringPointDirection}} ({{mpm.nameFriendly}})<br>-->
<!--          &nbsp;&nbsp; {{mpm.dateStart.toLocaleDateString(localeToUse) }} >> {{mpm.dateEnd?.toLocaleDateString(localeToUse)}}-->
<!--             {{mpm.countMonth}} Zählpunktmonate <br>-->
<!--        </div>-->

        <u>EnergieABhängiges Modell: Mitgliedschaften aktiv zwischen {{ billingPeriodDateStart2025.toLocaleDateString(localeToUse) }} und {{ billingPeriodDateEnd2025.toLocaleDateString(localeToUse) }}:</u>
        <div v-for="(mpm, index) of community.mpms2025" :key="index">
          {{index+1}}: {{mpm.meteringPoint}} {{mpm.meteringPointDirection}} ({{mpm.nameFriendly}})<br>
          &nbsp;&nbsp; {{mpm.dateStart.toLocaleDateString(localeToUse) }} >> {{mpm.dateEnd?.toLocaleDateString(localeToUse)}}
          {{mpm.countMonth}} Zählpunktmonate <br>
        </div>


        <br>
      </div>




    </v-container>
  </v-container>
</template>
